import React from 'react';
import { VStack, Text, useTheme } from '@chakra-ui/react';
import HeroSection from '../components/common/HeroSection';
import Content from '../components/home/Content';
import VideoSection from '../components/home/VideoSection';
import MiniNavbar from '../components/common/MiniNavbar';

const Home = () => {

  return (
    <VStack spacing={0}>
      <HeroSection />
      {/* {isMobileView && <JoinCommunity />} */}
      <MiniNavbar />
      <Content />
      <VideoSection />
      {/* {!isMobileView &&<JoinCommunity />} */}
    </VStack>
  );
};

export default Home;
